var map = {
	"assets/blog/portfolio/springaroo.mdx": 1335,
	"assets/blog/software/asp-net-core-on-raspberry-pi-with-docker.mdx": 9259,
	"assets/blog/software/automatically-generating-open-graph-images.mdx": 7899,
	"assets/blog/software/automating-university-coursework-time-tracking.mdx": 4126,
	"assets/blog/software/building-a-full-stack-application-apsitvarkom.mdx": 9485,
	"assets/blog/software/creating-a-blog-from-scratch.mdx": 2714,
	"assets/blog/software/dotnet-e2e-testcontainers.mdx": 7284,
	"assets/blog/software/unit-testing-c-with-bash.mdx": 3018,
	"assets/blog/software/what-i-learned-in-a-year-as-a-front-end-developer.mdx": 1002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 376;